import React, { useState, useRef } from "react";
import { supabase } from "../lib/supabase";
import { S } from "../styles/tokens";
import { useEnter } from "../lib/motion";

export default function ResetPasswordView(props) {
  var cardRef = useRef(null);
  useEnter(cardRef, { y: 16, stagger: 0.07 });
  var [password, setPassword] = useState("");
  var [confirm, setConfirm] = useState("");
  var [loading, setLoading] = useState(false);
  var [err, setErr] = useState("");
  var [msg, setMsg] = useState("");

  async function handleReset(e) {
    e.preventDefault();
    setErr("");
    if (!password || !confirm) { setErr("Please fill in both fields."); return; }
    if (password.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (password !== confirm) { setErr("Passwords don't match."); return; }
    setLoading(true);
    // Make sure we have a session before updating
    var { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      setErr("Session expired. Please request a new password reset link.");
      setLoading(false);
      return;
    }
    var { error } = await supabase.auth.updateUser({ password: password });
    setLoading(false);
    if (error) { setErr(error.message); return; }
    setMsg("✓ Password updated! Redirecting to sign in…");
    setTimeout(function() { props.onDone(); }, 2000);
  }

  return (
    <div style={S.authWrap}>
      <div ref={cardRef} className="auth-card" style={S.authCard}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 48, height: 48, background: "#2c2420", borderRadius: 12, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
            <svg viewBox="0 0 22 22" fill="none" width={26} height={26}>
              <path d="M11 2L19 6.5V15.5L11 20L3 15.5V6.5L11 2Z" stroke="#f7f3ee" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M11 7V11L14 13" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round" />
              <circle cx={11} cy={11} r={1.8} fill="#c9963a" />
            </svg>
          </div>
          <div style={{ fontFamily: "Georgia,serif", fontSize: 22, fontWeight: 600, letterSpacing: 3, color: "#2c2420" }}>SYNTRIX</div>
          <div style={{ fontSize: 13, color: "#7a6e64", marginTop: 8 }}>Set your new password</div>
        </div>
        {err && <div style={S.errBar}>{err}</div>}
        {msg && <div style={{ background: "rgba(107,143,113,.08)", border: "1px solid rgba(107,143,113,.25)", borderRadius: 10, padding: "11px 14px", fontSize: 12, color: "#6b8f71", marginBottom: 14, textAlign: "center" }}>{msg}</div>}
        <form onSubmit={handleReset}>
          <label style={{ fontSize: 10, letterSpacing: 1.5, color: "#7a6e64", display: "block", marginBottom: 6 }}>NEW PASSWORD</label>
          <input style={S.authInput} type="password" placeholder="Min. 6 characters" value={password} onChange={function(e) { setPassword(e.target.value); }} autoFocus />
          <label style={{ fontSize: 10, letterSpacing: 1.5, color: "#7a6e64", display: "block", marginBottom: 6 }}>CONFIRM PASSWORD</label>
          <input style={S.authInput} type="password" placeholder="Repeat password" value={confirm} onChange={function(e) { setConfirm(e.target.value); }} />
          <button type="submit" style={{ ...S.authBtn, opacity: loading ? 0.6 : 1 }} disabled={loading}>
            {loading ? "Updating…" : "Set New Password →"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 24, fontSize: 10, color: "#7a6e64", letterSpacing: 1 }}>
          🔒 SECURE · SSL ENCRYPTED · DATA NEVER SOLD
        </div>
      </div>
    </div>
  );
}
